<template>
  <div>
    <form
      autocomplete="off"
      @submit.prevent="handleSubmit"
    >
      <div>
        <div class="mb-4 input-field">
          <input
            id="email"
            v-model="formData.email"
            v-focus
            class="input-field"
            type="text"
            name="email"
            placeholder="Email"
          >
        </div>

        <AppButton
          :disabled="isSubmitting"
          class="bg-primary text-white"
        >
          {{ isSubmitting ? 'Sending email...' : 'Send email' }}
        </AppButton>

        <BackButton :back-route-name="{ name: 'app_auth_login' }">
          Back to login
        </BackButton>
      </div>
    </form>
  </div>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive, ref } from 'vue';

import { AppButton, BackButton } from '@/components/buttons';

import { useHttp } from '@/composables';

const emit = defineEmits(['email-sent']);

const formData = reactive({
  email: import.meta.env.DEV ? 'admin@example.com' : null,
});

const isSubmitting = ref(false);

const handleSubmit = async () => {
  isSubmitting.value = true;

  const response = await useHttp().post(
    '/auth/forgot-password',
    { email: formData.email },
  );

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('email-sent', formData.email);
  }

  isSubmitting.value = false;
};
</script>
